var cbs = [], 
	data;
module.exports = function(cb) {
	if(cbs) cbs.push(cb);
	else cb(data);
}
require.ensure([], function(require) {
	data = require("!!../../../../../../node_modules/babel-loader/lib/index.js?{\"presets\":[\"es2015\",\"react\",\"stage-0\"],\"plugins\":[\"transform-runtime\",\"transform-flow-strip-types\",\"transform-react-constant-elements\",\"transform-react-inline-elements\"]}!./community.js");
	var callbacks = cbs;
	cbs = null;
	for(var i = 0, l = callbacks.length; i < l; i++) {
		callbacks[i](data);
	}
});


//////////////////
// WEBPACK FOOTER
// ./~/bundle-loader!./app/assets/js/modules/admin/controllers/community.js
// module id = 236
// module chunks = 0